import { Button, ButtonProps } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import React from "react";

interface DeleteProductButtonProps extends Omit<ButtonProps, "onClick"> {
  onClick: () => void;
  label: string;
  tooltipText?: string;
  disabled?: boolean;
}

const DeleteProductButton: React.FC<DeleteProductButtonProps> = ({
  onClick,
  label,
  tooltipText,
  disabled = false,
  ...buttonProps
}) => {
  const ButtonComponent = (
    <Button
      {...buttonProps}
      variant="tertiary"
      destructive
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </Button>
  );

  return (
    <>
      {tooltipText ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <div>{ButtonComponent}</div>
          </TooltipTrigger>
          <TooltipContent>{tooltipText}</TooltipContent>
        </Tooltip>
      ) : (
        ButtonComponent
      )}
    </>
  );
};

export default DeleteProductButton;
